import { gql } from '@apollo/client';

export const GET_VERIFICATION_DATA = gql`
    query VerificationData(
        $method: String!
        $startDate: String!
        $endDate: String!
    ) {
        verificationData(
            method: $method,
            startDate: $startDate,
            endDate: $endDate,
        ) {
            verificationItems {
                verificationState
                verificationResult
                verificationDocumentSubmittedAt
                verificationVerifiedAt
            }
            statistics {
                date
                totalNum
                approveNum
                deniedNum
                inProgressNum
            }
            longestVerificationTimeMinutes
            totalNum
            approvedNum
            deniedNum
            inProgressNum
        }
    }`;